import PubSub from 'pubsub-js';
import { TOPICS } from './constants';
export var toasts = {
  showToast: function showToast(toast) {
    PubSub.publish(TOPICS.SHOW_TOAST, toast);
  },
  removeToast: function removeToast(id) {
    PubSub.publish(TOPICS.REMOVE_TOAST, id);
  }
};